module.exports = __webpack_public_path__ + "img/error-info.1d2e35b5.svg";